export const ROLES = {
  ADMIN: 'ADMIN',
  USER: 'USER',
} as const;

export const MAX_UPLOADED_FILE_SIZE = 20 * 1024 * 1024; // 20MB

export const UPLOAD_STATUS = {
  IDLE: 'IDLE',
  LOADING: 'LOADING',
  FULFILLED: 'FULFILLED',
  ERROR: 'ERROR',
  CANCELLED: 'CANCELLED',
} as const;

export const UPLOAD_ANALYSIS_STEP = {
  INITIAL: 0,
  LOADING: 1,
  RESULTS: 2,
} as const;

export const UPLOAD_INPUT_TYPE = {
  VIDEO_URL: 'videoUrl',
  VIDEO_FILE: 'videoFile',
  IMAGE_URL: 'imageUrl',
  IMAGE_FILE: 'imageFile',
} as const;
